import React from 'react';

const AppContext = React.createContext({ showModal: (title: string, message: string, className?: string) => { }, showAfexModal: () => { }, showLoadingModal: () => { }, hideLoadingModal: () => { }, showForgotPasswordModal: () => { }, hideModal: () => { }, updateMessages: () => { } });

export const AppProvider = AppContext.Provider;
export const AppConsumer = AppContext.Consumer;

export default AppContext;
